import * as React from "react";
import PermissionContext from "../Contexts/PermissionContext";

export default function WithUserContext(Component:any) {
    return function PermissionComponent(props:any) {
        return (
            <PermissionContext.Consumer>
                {(context) => <Component {...props} context={context} />}
            </PermissionContext.Consumer>
        );
    };
}
